import { useTheme } from "@mui/material";
import { useParams } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { EnvVariable } from "./type";
// import SettingsIcon from "@mui/icons-material/Settings";
import BusinessIcon from "@mui/icons-material/Business";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import RecentActorsIcon from "@mui/icons-material/RecentActors";
import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
import TerminalIcon from "@mui/icons-material/Terminal";
import SubtitlesIcon from "@mui/icons-material/Subtitles";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import AppearanceIcon from "@mui/icons-material/ColorLens";
import OrganizationIcon from "@mui/icons-material/AcUnit";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
// @ts-ignore
import { copy } from "copy-anything";
import {
  COMPANY_INFORMATION_PATH,
  DEPARTMENT_PATH,
  TEAMS_PATH,
  USERS_PATH,
  BUSINESS_APPLICATIONS_PATH,
  ENV_TOPOLOGY_PATH,
  INTEGRATION_PATH,
  APPEARANCE_PATH,
  API_INFO_PATH,
  ROLE_BASED_AUTH_ROLE_PATH,
  ROLE_BASED_AUTH_ROLE_CREATE_PATH,
  ROLE_BASED_AUTH_ROLE_DETAILS_PATH_MATCHING,
  TEAMS_CREATE_PATH,
  TEAMS_DETAILS_PATH_MATCHING,
  BUSINESS_APPLICATIONS_CREATE_PATH,
  BUSINESS_APPLICATIONS_DETAILS_PATH_MATCHING,
  ORGANIZATION_PATH,
  PERSONALLY_IDENTIFIABLE_INFORMATION,
  API_CATEGORIZATION_PATH,
  ROLE_BASED_AUTH_SCREEN_CREATE_PATH,
  ROLE_BASED_AUTH_SCREEN_DETAILS_PATH_MATCHING,
  ADD_SCREEN_ROLE_MAPPING_PATH,
  UPDATE_SCREEN_ROLE_MAPPING_PATH_MATCHING,
} from "./Constant";
// import CategorizationIcon from "../../assets/icons/API_Categorization.svg?react";

export const hexToRgba = (hex, alpha) => {
  const match = hex.match(/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i);
  if (!match) return hex; // Return original color if invalid hex
  const [, r, g, b] = match.map((v) => parseInt(v, 16));
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const findItems = (items: any[], id: string): any => {
  for (const item of items) {
    if (item.itemId === id) {
      return item;
    }
    if (item.children) {
      const found = findItems(item.children, id);
      if (found) {
        return found;
      }
    }
  }
  return null;
};

export const addCollectionIdToChildren = (
  data: any[],
  collectionId: string
) => {
  const traverse = (node: any, collectionId: string) => {
    const tmpChildren: any[] = [];
    if (Array.isArray(node.children) && node.children.length > 0) {
      let newChild;
      node.children.forEach((child: any) => {
        newChild = traverse(child, collectionId);
        tmpChildren.push(newChild);
      });
    }
    const newObj = { ...node, children: tmpChildren, collectionId };
    return newObj;
  };

  return traverse(data, collectionId);
};

export const getId = () => uuidv4();

export const convertToResHeaders = (resHeaders: any) => {
  const keys = Object.keys(resHeaders);
  return keys.map((item) => {
    return { key: item, value: resHeaders[item] };
  });
};

export const getColorBasedOnMethod = (method: string) => {
  switch (method) {
    case "GET":
      return "#8cc982";
    case "POST":
      return "#af8851";
    case "PUT":
      return "#799ad4";
    case "DELETE":
      return "orange";
    case "PATCH":
      return "#ab9ac9";
    case "ENV":
      return "#f0c674";
    default:
      return "gray";
  }
};

export const getColorBasedOnStatus = (status: number) => {
  if (status >= 200 && status < 300) {
    return "#8cc982";
  } else if (status >= 300 && status < 400) {
    return "#799ad4";
  } else if (status >= 400 && status < 500) {
    return "#ffcc00";
  } else {
    return "#ff0000";
  }
};

export const MonacoTheme = () => {
  const theme = useTheme();
  return theme.palette.mode === "dark" ? "vs-dark" : "vs";
};

export const CurrentRequestId = () => {
  const params = useParams();
  return params.requestId as string;
};

export const availableScripts = [
  {
    name: "Get a global variable",
    script: 'ata.globals.get("variable_key");\n',
    visible: "pre-post",
  },
  {
    name: "Set a global variable",
    script: 'ata.globals.set("variable_key", "variable_value");\n',
    visible: "pre-post",
  },
  {
    name: "Clear a global variable",
    script: 'ata.globals.unset("variable_key");\n',
    visible: "pre-post",
  },
  {
    name: "Get an environment variable",
    script: 'ata.environment.get("variable_name");\n',
    visible: "pre-post",
  },
  {
    name: "Set an environment variable",
    script: 'ata.environment.set("variable_key", "variable_value");\n',
    visible: "pre-post",
  },
  {
    name: "Clear an environment variable",
    script: 'ata.environment.unset("variable_key");\n',
    visible: "pre-post",
  },
  {
    name: "Send a request",
    script:
      'ata.sendRequest("https://postman-echo.com/get", function (err, response) {\n\tconsole.log(response);\n});\n',
    visible: "pre-post",
  },
  {
    name: "Response Header - Content Type Header Check",
    script:
      'ata.test("Content-Type is present", function () {\n\tata.expect(ata.response.getHeader("Content-Type")).toBe("application/json");\n});\n',
    visible: "postResponseScript",
  },
  {
    name: "Response body: is equal to a string",
    script:
      'ata.test("Body matches expected", function () {\n\tata.response.to.have.body("expected_response_body");\n});\n',
    visible: "postResponseScript",
  },
  {
    name: "Status code: code is 200",
    script:
      'ata.test("Status code is 200", function () {\n\tata.expect(ata.response.getStatusCode()).toBe(200);\n});\n',
    visible: "postResponseScript",
  },
  {
    name: "Response time is less than 200ms",
    script:
      'ata.test("Response time check", function () {\n\tata.expect(ata.response.getResponseTime()).toBeLessThan(200);\n});\n',
    visible: "postResponseScript",
  },
  {
    name: "Status code: Successful POST request",
    script:
      'ata.test("Successful POST request", function () {\n\tata.expect(ata.response.getStatusCode()).toBe(201);\n});\n',
    visible: "postResponseScript",
  },
  {
    name: "Status code: code message name has string",
    script:
      'ata.test("Status message check", function () {\n\tconst response = ata.response.json();\n\tata.expect(response.message).toContain("success");\n});\n',
    visible: "postResponseScript",
  },
  {
    name: "Response body: Convert XML body to a JSON Object",
    script:
      'const jsonData = ata.response.xml2Json();\nconsole.log("Converted JSON:", jsonData);\n',
    visible: "postResponseScript",
  },
  {
    name: "Use tiny validator for JSON data",
    script:
      'ata.test("Validate JSON structure", function () {\n\tconst data = ata.response.json();\n\tata.expect(data).toContain("required_field");\n\tata.expect(typeof data.id).toBe("number");\n});\n',
    visible: "postResponseScript",
  },
];

export const parseEnvironment = ({
  // @ts-ignore
  prefix: { start, end },
  // @ts-ignore
  options: { keyColumn, valueColumn, initValueColumn },
  // @ts-ignore
  data: { chars, arr },
}) => {
  let str = decodeURI(encodeURI(chars).replaceAll("%EF%BB%BF", ""));
  const newArr = [...arr];

  for (let i = 0; i < newArr.length; i++) {
    const currentKey = newArr[i][keyColumn];

    // Find duplicates with the same key
    const matchingMentions = newArr.filter(
      (mention) => mention[keyColumn] === currentKey
    );

    if (matchingMentions.length > 1) {
      // If there are multiple matches, prefer the non-global one
      const nonGlobal = matchingMentions.find(
        (mention) => mention.isGlobal === false
      );
      if (nonGlobal) {
        newArr[i] = nonGlobal;
      }
    }

    const index = str.indexOf(`${start}${currentKey}${end}`);

    if (index !== -1) {
      str = str.replaceAll(
        `${start}${currentKey}${end}`,
        `${newArr[i][valueColumn] || newArr[i][initValueColumn]}`
      );
    }
  }
  return str;
};

export const isValidJSON = (_json: any) => {
  // if (!_.isString(json)) return false;
  // try {
  //   JSON.parse(json);
  // } catch (e) {
  //   return false;
  // }
  return true;
};

export const CATEGORIES = {
  COLLECTION: "COLLECTION",
  REQUEST: "REQUEST",
  FOLDER: "FOLDER",
  ENVIRONMENT: "ENVIRONMENT",
  HISTORY: "HISTORY",
};

export const getErrorMessage = (error: any) => {
  if (error) {
    if ("status" in error) {
      return error.data?.message || "Something went wrong";
    } else if (error instanceof Error) {
      return error.message;
    }
  }
  return null;
};

export const parseHistoryList = (folderInfo: any) => {
  if (Array.isArray(folderInfo)) {
    return folderInfo.map((item) => {
      let tid: any = { id: "", name: "", method: "", children: [] };
      tid.id = item.historyId;
      tid.name =
        item?.itemName ||
        item?.itemName ||
        item?.reqApiUrl ||
        item?.requestData?.url;
      tid.type = "REQUEST";
      tid.method = item?.requestData?.reqMethod;

      return { ...item, ...tid };
    });
  }

  return Object.keys(folderInfo).map((key) => {
    let tid: any = { id: "", name: "", method: "", children: [] };
    tid.id = key;
    tid.name = key;
    tid.type = "COLLECTION";
    tid.method = "";
    tid.allowSelect = false;
    tid.isDeleteDate = true;
    tid.userId = folderInfo[key][0]?.userId;

    if (folderInfo[key] && Array.isArray(folderInfo[key]))
      tid.children = parseHistoryList(folderInfo[key]);

    return { ...tid };
  });
};

export const hasDuplicates = (
  variables: EnvVariable[] | undefined
): boolean => {
  if (!Array.isArray(variables)) return false;

  const nameCount = variables.reduce((acc, { variableName }) => {
    acc[variableName] = (acc[variableName] || 0) + 1;
    return acc;
  }, {} as Record<string, number>);

  return Object.values(nameCount).some((count) => count > 1);
};

export const findDuplicates = (rows: EnvVariable[]) => {
  const nameCount: Record<string, string[]> = {};
  rows.forEach((row) => {
    if (!nameCount[row.variableName]) {
      nameCount[row.variableName] = [];
    }
    nameCount[row.variableName].push(row._id);
  });
  const duplicates = Object.values(nameCount).filter((ids) => ids.length > 1);
  return new Set(duplicates.flat());
};

interface ExportJsonFileParams {
  fileName: string;
  platform: string;
  data: unknown;
}

export const exportJsonFile = ({
  fileName,
  platform,
  data,
}: ExportJsonFileParams) => {
  // create file in browser
  const json = JSON.stringify(data, null, 2);
  const blob = new Blob([json], { type: "application/json" });
  const href = URL.createObjectURL(blob);

  // create "a" HTLM element with href to file
  const link = document.createElement("a");
  link.href = href;
  link.download = fileName + "_" + platform + ".json";
  document.body.appendChild(link);
  link.click();

  // clean up "a" element & remove ObjectURL
  document.body.removeChild(link);
  URL.revokeObjectURL(href);
};

export const BASIC_ACTION = {
  ADD: "add",
  VIEW: "view",
  DOWNLOAD: "download",
  MANAGE: "manage",
  EDIT: "edit",
  DELETE: "delete",
  MOVE: "move",
  DUPLICATE: "duplicate",
  ACTIVE: "active",
  INACTIVE: "inactive",
  ARCHIVE: "archive",
  RESTORE: "restore",
  PENDING: "pending",
  REPORT: "report",
  STOP: "stop",
  PAUSE: "pause",
  ADDRECORD: "add record",
  MOVEUP: "move up",
  MOVEDOWN: "move down",
  GO_TO_REQUEST: "go to request",
  PUBLISH_TO_RULES_LIBRARY: "publish to rules library",
};

export const getOnlyRequests = (items: any[]) => {
  // need to check if items is array and each item has children too
  if (!Array.isArray(items)) return [];
  const newRequests: any[] = [];
  items.forEach((item) => {
    if (item.itemCatagory === "REQUEST") {
      newRequests.push(item);
    }
    if (item.children && item.children.length > 0) {
      const childRequests = getOnlyRequests(item.children);
      newRequests.push(...childRequests);
    }
  });
  return newRequests;
};

export const convertToFormData = (formData: any[] = []) => {
  const form = new FormData();
  formData.forEach((item) => {
    if (item.key && item.value) {
      if (item.type === "File" && item.value instanceof File) {
        form.append(item.key, item.value);
      } else {
        form.append(item.key, item.value.toString());
      }
    }
  });
  return form;
};

export function replaceRequestWithDetail(originalData: any, newItems: any) {
  let baseJson = copy(originalData);
  function findAndReplaceItems(dataArray: any, newItem: any) {
    for (let i = 0; i < dataArray.length; i++) {
      if (dataArray[i]?.itemId === newItem?.itemId) {
        dataArray[i] = { ...dataArray[i], ...newItem };
      }
      if (dataArray[i]?.children && dataArray[i]?.children?.length > 0) {
        findAndReplaceItems(dataArray[i].children, newItem);
      }
    }
  }

  if (Array.isArray(newItems) && newItems?.length) {
    newItems?.forEach((newItem) => {
      findAndReplaceItems(baseJson?.children, newItem);
    });
  }
  return baseJson;
}

export const sidebarItems = [
  // {
  //   id: "company-management",
  //   name: "Company Management",
  //   icon: <SettingsIcon />,
  //   show: true,
  //   disable: false,
  //   children: [
  {
    id: "company-information",
    name: "Company Information",
    icon: <BusinessIcon />,
    route: COMPANY_INFORMATION_PATH,
    matchingRoutes: [COMPANY_INFORMATION_PATH],
    show: true,
    disable: false,
  },
  {
    id: "organization",
    name: "Organization",
    icon: <OrganizationIcon />,
    route: ORGANIZATION_PATH,
    matchingRoutes: [ORGANIZATION_PATH],
    show: true,
    disable: false,
  },
  {
    id: "department",
    name: "Department",
    icon: <CreditScoreIcon />,
    route: DEPARTMENT_PATH,
    matchingRoutes: [DEPARTMENT_PATH],
    show: true,
    disable: false,
  },
  {
    id: "teams",
    name: "Teams",
    icon: <GroupAddIcon />,
    route: TEAMS_PATH,
    matchingRoutes: [
      TEAMS_PATH,
      TEAMS_CREATE_PATH,
      TEAMS_DETAILS_PATH_MATCHING,
    ],
    show: true,
    disable: false,
  },
  {
    id: "users",
    name: "Users",
    icon: <Diversity3Icon />,
    route: USERS_PATH,
    matchingRoutes: [USERS_PATH],
    show: true,
    disable: false,
  },
  {
    id: "role-based-auth",
    name: "Role Based Auth",
    icon: <RecentActorsIcon />,
    route: ROLE_BASED_AUTH_ROLE_PATH,
    matchingRoutes: [
      ROLE_BASED_AUTH_ROLE_PATH,
      ROLE_BASED_AUTH_ROLE_CREATE_PATH,
      ROLE_BASED_AUTH_ROLE_DETAILS_PATH_MATCHING,
      ROLE_BASED_AUTH_SCREEN_CREATE_PATH,
      ROLE_BASED_AUTH_SCREEN_DETAILS_PATH_MATCHING,
      ADD_SCREEN_ROLE_MAPPING_PATH,
      UPDATE_SCREEN_ROLE_MAPPING_PATH_MATCHING,
    ],
    show: true,
    disable: false,
  },
  {
    id: "business-applications",
    name: "Business Applications",
    icon: <WorkHistoryIcon />,
    route: `${BUSINESS_APPLICATIONS_PATH}?all=true`,
    matchingRoutes: [
      BUSINESS_APPLICATIONS_PATH,
      BUSINESS_APPLICATIONS_CREATE_PATH,
      BUSINESS_APPLICATIONS_DETAILS_PATH_MATCHING,
    ],
    show: true,
    disable: false,
  },
  {
    id: "environment-topology",
    name: "Env Topology",
    icon: <TerminalIcon />,
    route: ENV_TOPOLOGY_PATH,
    matchingRoutes: [ENV_TOPOLOGY_PATH],
    show: true,
    disable: false,
  },
  {
    id: "integration",
    name: "Integration",
    icon: <SubtitlesIcon />,
    route: INTEGRATION_PATH,
    matchingRoutes: [INTEGRATION_PATH],
    show: true,
    disable: false,
  },
  {
    id: "appearance",
    name: "Appearance",
    icon: <AppearanceIcon />,
    route: APPEARANCE_PATH,
    matchingRoutes: [APPEARANCE_PATH],
    show: true,
    disable: false,
  },
  {
    id: "PII",
    name: "Personally Identifiable Information",
    icon: <AdminPanelSettingsOutlinedIcon />,
    route: PERSONALLY_IDENTIFIABLE_INFORMATION,
    matchingRoutes: [PERSONALLY_IDENTIFIABLE_INFORMATION],
    show: true,
    disable: false,
  },
  {
    id: "api-categorization",
    name: "API Exposure Types",
    icon: <Inventory2Icon />,
    route: API_CATEGORIZATION_PATH,
    matchingRoutes: [API_CATEGORIZATION_PATH],
    show: true,
    disable: false,
  },
  {
    id: "api-info",
    name: "API Info",
    icon: <Inventory2Icon />,
    route: API_INFO_PATH,
    matchingRoutes: [API_INFO_PATH],
    show: true,
    disable: false,
  },

  //   ],
  // },
];

export const preprocessCurlCommand = (curlCommand: string) => {
  curlCommand = curlCommand.replace(/\\'/g, "'");
  curlCommand = curlCommand.replace(/\\\n/g, " ");
  return curlCommand.trim();
};

export const divideArray = (arr: any[], chunkSize: number) => {
  const dividedArrays = [];

  for (let i = 0; i < arr.length; i += chunkSize) {
    const chunk = arr.slice(i, i + chunkSize);
    dividedArrays.push([...chunk]);
  }

  return dividedArrays;
};

export function deduplicateItems(items: any) {
  const seen = new Set();
  const uniqueItems: any[] = [];

  items?.forEach((item: any) => {
    const key = `${item.itemId}-${item.iteration}`;
    if (!seen?.has(key)) {
      uniqueItems.push(item);
      seen?.add(key);
    }
  });

  return uniqueItems;
}

export const processFilterParams = (params: any) => {
  return Object.fromEntries(
    Object.entries(params).map(([key, value]) => [
      key,
      (value as string)?.replace(/OR/g, " "),
    ])
  );
};

export const camelToNormal = (value: string) => {
  value = value || "";
  const formattedValue = value.includes(" ")
    ? value
    : value.replace(/([a-z])([A-Z])/g, "$1 $2");
  const capitalizedValue =
    formattedValue.charAt(0).toUpperCase() + formattedValue.slice(1);

  return capitalizedValue;
};

export interface StepData {
  [key: string]: {
    title: string;
    description: string;
    stepNumber: number;
    enabled: boolean;
  };
}

export const valueToStep = {
  1: "General Info*",
  2: "Configure E2E Testing",
  3: "Configure Robustness Testing",
  4: "Configure Security Testing",
};

export const removeHtmlTags = (htmlString: any) => {
  // Create a new DOM element
  const doc = new DOMParser().parseFromString(htmlString, "text/html");
  return doc.body.textContent || "";
};

export const truncateText = (text: string, length: number) => {
  if (text.length <= length) return text;
  return text.substring(0, length) + "..."; // Truncate text to the specified length and add '...'
};

export const toCamelCaseDisplay = (str: string) => {
  if (!str) return "";

  return str
    ?.toLowerCase()
    ?.split(/[_\s-]+/) // Split by underscore, space, or hyphen
    ?.map((word) => word?.charAt(0)?.toUpperCase() + word?.slice(1))
    ?.join(" ");
};
